export const isProfileSpec = (spec) => spec.dataLayerId !== undefined &&
    spec.label !== undefined;
/*
  Site Profile Specs
*/
// <ConditionsTab>
export const conditionsTabProfile = {
    // <SiteCard>
    landCover: {
        dataLayerId: 'data-layer-land-cover-en',
        queryType: 'raster',
        queryLayer: 'la-impervious-surface',
        aggregationMethod: 'categoricalPercentage',
        label: {
            english: 'Land Cover',
            spanish: 'Cubierta terrestre'
        }
    },
    // <StormwaterSection>
    annualRainfall: {
        dataLayerId: '40630c55-8bb8-4a52-8b3c-7c1e6f42dde8',
        queryType: 'raster',
        queryLayer: 'annual-rainfall',
        aggregationMethod: 'volumeOverAreas',
        label: {
            english: 'Rainfall',
            spanish: 'Precipitación'
        },
        singularUnits: {
            english: 'Gallon',
            spanish: 'Galón'
        },
        pluralUnits: {
            english: 'Gallons',
            spanish: 'Galones'
        }
    },
    stormEventRainfall: {
        dataLayerId: 'data-layer-precipitation-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-storm-event',
        attributes: ['rainfall'],
        aggregationMethod: 'volumeOverAreas',
        label: {
            english: 'Rainfall',
            spanish: 'Precipitación'
        }
    },
    rainfallRunoffTotal: {
        dataLayerId: '9fc75e8f-35f4-46d1-8923-6d9cf4cecc25',
        queryType: 'raster',
        includeBufferedArea: true,
        queryLayer: 'la-runoff-contribution-areas-total',
        aggregationMethod: 'max',
        label: {
            english: 'Contribution Area',
            spanish: 'Área de Contribución'
        },
        singularUnits: {
            english: 'acre',
            spanish: 'acre'
        },
        pluralUnits: {
            english: 'acres',
            spanish: 'acres'
        }
    },
    rainfallRunoffImpervious: {
        dataLayerId: '9fc75e8f-35f4-46d1-8923-6d9cf4cecc25',
        queryType: 'raster',
        includeBufferedArea: true,
        queryLayer: 'la-runoff-contribution-areas-impervious',
        aggregationMethod: 'max',
        label: {
            english: 'impervious',
            spanish: 'impermeable'
        },
        singularUnits: {
            english: 'acre',
            spanish: 'acre'
        },
        pluralUnits: {
            english: 'acres',
            spanish: 'acres'
        }
    },
    rainfallRunoffPervious: {
        dataLayerId: '9fc75e8f-35f4-46d1-8923-6d9cf4cecc25',
        queryType: 'raster',
        includeBufferedArea: true,
        queryLayer: 'la-runoff-contribution-areas-pervious',
        aggregationMethod: 'max',
        label: {
            english: 'pervious',
            spanish: 'permeable'
        },
        singularUnits: {
            english: 'acre',
            spanish: 'acre'
        },
        pluralUnits: {
            english: 'acres',
            spanish: 'acres'
        }
    },
    groundwaterBasin: {
        dataLayerId: 'f07f4e41-8c37-4139-b710-32af0de2b529',
        queryType: 'featureProperties',
        queryLayer: 'groundwater-basins',
        attributes: ['basin_name'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Groundwater Basin',
            spanish: 'Cuenca de agua subterránea'
        }
    },
    infiltration: {
        // only show card if groundwaterBasins.length > 0
        dataLayerId: '401fa35c-af57-4ef8-99dd-0fad2ffa948f',
        queryType: 'raster',
        queryLayer: 'infiltration',
        aggregationMethod: 'mean',
        label: {
            english: 'Infiltration',
            spanish: 'Infiltración'
        },
        singularUnits: {
            english: 'inch per hour',
            spanish: 'pulgada por hora'
        },
        pluralUnits: {
            english: 'inches per hour',
            spanish: 'pulgadas por hora'
        }
    }
};
// <SiteTab>
export const detailsTabProfile = {
    // Site table
    roofCover: {
        dataLayerId: 'data-layer-roofs-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-roofs-v2',
        aggregationMethod: 'totalFeatureArea',
        label: {
            english: 'Roof Cover',
            spanish: 'Cubierta del tejado'
        }
    },
    landOwnership: {
        dataLayerId: 'data-layer-parcels-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-parcels',
        attributes: ['agency_name'],
        aggregationMethod: 'uniqueList',
        defaultAttributeValue: 'Private',
        label: {
            english: 'Land Ownership',
            spanish: 'Titularidad del terreno'
        }
    },
    // Land Use card
    landUse: {
        dataLayerId: 'data-layer-parcels-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-parcels',
        attributes: ['land_use_type'],
        aggregationMethod: 'categoricalPercentage',
        label: {
            english: 'Land Use',
            spanish: 'Uso de tierra'
        }
    },
    parcelNumbers: {
        // only for exports
        dataLayerId: 'data-layer-parcels-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-parcels',
        attributes: ['ain'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Assessor Parcel Numbers',
            spanish: 'Números de Parcela del Evaluador'
        }
    },
    // Policy Details cards
    disadvantagedCommunity: {
        dataLayerId: 'data-layer-disadvantaged-communities-en',
        queryType: 'featureProperties',
        queryLayer: 'la-disadvantaged-communities',
        aggregationMethod: 'count',
        label: {
            english: 'Disadvantaged Community',
            spanish: 'Comunidad desfavorecida'
        },
        singularUnits: {
            english: 'Using CalEPA SB 535 designation',
            spanish: 'Usando la designación CalEPA SB 535'
        }
    },
    disadvantagedCommunityBuffer: {
        dataLayerId: 'data-layer-disadvantaged-communities-en',
        queryType: 'featureProperties',
        queryLayer: 'la-disadvantaged-communities',
        includeBufferedArea: true,
        aggregationMethod: 'count',
        label: {
            english: 'Within site walkshed',
            spanish: 'Dentro de la zona de caminata del sitio'
        }
    },
    calenviroscreen: {
        dataLayerId: 'data-layer-calenviroscreen-en',
        queryType: 'featureGeojson',
        queryLayer: 'ca-calenviroscreen',
        attributes: ['calenviroscreen_score_percentile'],
        aggregationMethod: 'weightedAverage',
        label: {
            english: 'CalEnviroScreen Score',
            spanish: 'Puntuación de CalEnviroScreen'
        },
        singularUnits: {
            english: 'percentile',
            spanish: 'percentil'
        }
    },
    existingProjects: {
        dataLayerId: 'data-layer-existing-projects-en',
        queryType: 'featureProperties',
        queryLayer: 'la-existing-projects',
        includeBufferedArea: true,
        aggregationMethod: 'count',
        label: {
            english: 'Existing Projects',
            spanish: 'Proyectos existentes'
        },
        singularUnits: {
            english: 'in walkshed',
            spanish: 'en área de caminata'
        }
    },
    // Location cards
    municipalities: {
        dataLayerId: 'data-layer-municipalities-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-municipalities',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Municipality',
            spanish: 'Municipio'
        }
    },
    supervisorialDistricts: {
        dataLayerId: 'data-layer-supervisorial-districts-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-supervisorial-districts',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Supervisorial District',
            spanish: 'Distrito de supervisión'
        }
    },
    censusTracts: {
        dataLayerId: 'data-layer-census-tracts-en',
        queryType: 'featureProperties',
        queryLayer: 'la-census-tracts',
        attributes: ['geoid'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Census Tract',
            spanish: 'Zona censal'
        }
    },
    neighborhoods: {
        dataLayerId: 'data-layer-neighborhoods-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-neighborhoods',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Neighborhood',
            spanish: 'Vecindario'
        }
    },
    scwpWatershedArea: {
        dataLayerId: '4f6f4134-4fd1-49d8-8d26-89de54d5f469',
        queryType: 'featureProperties',
        queryLayer: 'la-watershed-scwp-areas',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'SCWP Watershed Area',
            spanish: 'Área de cuenca de SCWP'
        }
    },
    hydrologicWatershed: {
        dataLayerId: '9fda414a-b594-4b41-9498-30c3528befc6',
        queryType: 'featureProperties',
        queryLayer: 'la-watershed-hydrologic',
        attributes: ['watershed_name', 'name'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Hydrologic Watershed',
            spanish: 'Cuenca Hidrológica'
        }
    },
    subwatershed: {
        dataLayerId: 'bb9da9e3-379e-4c76-9799-f93751408858',
        queryType: 'featureProperties',
        queryLayer: 'la-watershed-sub-watershed',
        attributes: ['name', 'id', 'name2', 'watershed'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Subwatershed',
            spanish: 'Subcuenca'
        }
    },
    historicHabitat: {
        dataLayerId: 'data-layer-historic-habitats-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-historic-habitats',
        attributes: ['habitat_type'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Historical Habitat',
            spanish: 'Hábitat histórico'
        }
    },
    tribalArea: {
        dataLayerId: 'data-layer-tribal-areas-en',
        queryType: 'featureGeojson',
        queryLayer: 'la-tribal-areas',
        attributes: ['name'],
        aggregationMethod: 'uniqueList',
        label: {
            english: 'Indigenous Territories',
            spanish: 'Territorios Indígenas'
        }
    }
};
// <OpportunitiesSection>
export const benefitsMetadata = {
    'effect-air-quality': {
        queryType: 'featureGeojson',
        queryLayer: 'air-pollution-exposure',
        attributes: ['air_pollution_exposure'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            english: 'percentile air pollution exposure',
            spanish: 'exposición percentil a la contaminación del aire'
        },
        pluralUnits: {
            english: 'percentile air pollution exposure',
            spanish: 'exposición percentil a la contaminación del aire'
        },
        higherIsBetter: false
    },
    'effect-biodiversity': {
        queryType: 'raster',
        queryLayer: 'habitat',
        aggregationMethod: 'mean',
        singularUnits: {
            english: 'leaf area index',
            spanish: 'índice de área foliar'
        },
        pluralUnits: {
            english: 'leaf area index',
            spanish: 'índice de área foliar'
        },
        higherIsBetter: true
    },
    'effect-co2-reduction': {
        queryType: 'featureGeojson',
        queryLayer: 'carbon-footprint',
        attributes: ['totalemissions'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            english: 'ton of CO2 equivalent per year',
            spanish: 'tonelada de CO2 equivalente por año'
        },
        pluralUnits: {
            english: 'tons of CO2 equivalent per year',
            spanish: 'toneladas de CO2 equivalente por año'
        }
    },
    'effect-community': {
        queryType: 'raster',
        includeBufferedArea: false,
        queryLayer: 'community-spaces-density',
        aggregationMethod: 'max',
        singularUnits: {
            english: 'community space in 10-minute walkshed',
            spanish: 'espacio comunitario en un área de caminata de 10 minutos'
        },
        pluralUnits: {
            english: 'community spaces in 10-minute walkshed',
            spanish: 'espacios comunitarios en un área de caminata de 10 minutos'
        },
        higherIsBetter: true
    },
    'effect-cooling': {
        queryType: 'raster',
        queryLayer: 'heatwave-temperature',
        aggregationMethod: 'mean',
        singularUnits: {
            english: '°F average heatwave daytime high',
            spanish: 'promedio de temperatura máxima diurna de la ola de calor en °F'
        },
        pluralUnits: {
            english: '°F average heatwave daytime high',
            spanish: 'promedio de temperatura máxima diurna de la ola de calor en °F'
        }
    },
    'effect-flood-safety': {
        queryType: 'raster',
        queryLayer: 'flood-risk',
        aggregationMethod: 'mean',
        singularUnits: {
            english: 'meter flood depth (1% annual chance)',
            spanish: 'profundidad de inundación del medidor (1% de probabilidad anual)'
        },
        pluralUnits: {
            english: 'meters flood depth (1% annual chance)',
            spanish: 'profundidad de inundación en metros (1% de probabilidad anual)'
        }
    },
    'effect-food': {
        queryType: 'featureGeojson',
        queryLayer: 'food-access',
        attributes: ['access'],
        aggregationMethod: 'valueOfMaxOverlap',
        singularUnits: {
            english: 'food access',
            spanish: 'acceso a alimentos'
        },
        pluralUnits: {
            english: 'food access',
            spanish: 'acceso a alimentos'
        },
        higherIsBetter: true
    },
    'effect-jobs': {
        queryType: 'featureGeojson',
        queryLayer: 'jobs',
        attributes: ['median_income'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            english: 'dollar per year median household income',
            spanish: 'ingreso medio de los hogares en dólares por año'
        },
        pluralUnits: {
            english: 'dollars per year median household income',
            spanish: 'ingreso medio de los hogares en dólares por año'
        },
        higherIsBetter: true
    },
    'effect-mobility': {
        queryType: 'raster',
        queryLayer: 'transit-options',
        aggregationMethod: 'max',
        singularUnits: {
            english: 'mobility option in 10-minute walkshed',
            spanish: 'opción de movilidad en un área de caminata de 10 minutos'
        },
        pluralUnits: {
            english: 'mobility options in 10-minute walkshed',
            spanish: 'opciones de movilidad en un área de caminata de 10 minutos'
        },
        higherIsBetter: true
    },
    'effect-personal-health': {
        queryType: 'featureGeojson',
        queryLayer: 'life-expectancy',
        attributes: ['leb'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            english: 'year of life expectancy at birth',
            spanish: 'año de esperanza de vida al nacer'
        },
        pluralUnits: {
            english: 'years of life expectancy at birth',
            spanish: 'años de esperanza de vida al nacer'
        },
        higherIsBetter: true
    },
    'effect-recreation': {
        queryType: 'raster',
        queryLayer: 'park-space-density',
        aggregationMethod: 'max',
        singularUnits: {
            english: 'acre of green space in 10-minute walkshed',
            spanish: 'acre de espacio verde en un área de caminata de 10 minutos'
        },
        pluralUnits: {
            english: 'acres of green space in 10-minute walkshed',
            spanish: 'acres de espacio verde en un área de caminata de 10 minutos'
        },
        higherIsBetter: true
    },
    'effect-soil-health': {
        queryType: 'raster',
        queryLayer: 'la-impervious-surface',
        aggregationMethod: 'categoricalPercentage',
        // returns a list, find categoricalPercentage.id === 20
        singularUnits: {
            english: '% impervious surface',
            spanish: '% superficie impermeable'
        },
        pluralUnits: {
            english: '% impervious surface',
            spanish: '% superficie impermeable'
        }
    },
    'effect-water-quality': {
        queryType: 'featureGeojson',
        queryLayer: 'water-pollutant-loading',
        attributes: ['pss_norm_areaweigh_pollloadng'],
        aggregationMethod: 'weightedAverage',
        singularUnits: {
            english: 'normalized water pollutant loading score',
            spanish: 'puntuación de carga de contaminantes del agua normalizada'
        },
        pluralUnits: {
            english: 'normalized water pollutant loading score',
            spanish: 'puntuación de carga de contaminantes del agua normalizada'
        }
    },
    'effect-water-supply': {
        queryType: 'raster',
        queryLayer: 'annual-rainfall',
        attributes: ['average_annual_precipitation'],
        aggregationMethod: 'volumeOverAreas',
        singularUnits: {
            english: 'gallons of runoff per year',
            spanish: 'galón de escorrentía por año'
        },
        pluralUnits: {
            english: 'gallons of runoff per year',
            spanish: 'galones de escorrentía por año'
        }
    }
};
// Use for binning if aggregationMethod == categoricalPercentage
export const percentBinning = {
    mapLayers: [
        {
            layerValues: [
                {
                    name: { english: 'Very Low' },
                    styleConfig: {
                        minValue: 0,
                        maxValue: 20
                    }
                },
                {
                    name: { english: 'Low' },
                    styleConfig: {
                        minValue: 20,
                        maxValue: 40
                    }
                },
                {
                    name: { english: 'Moderate' },
                    styleConfig: {
                        minValue: 40,
                        maxValue: 60
                    }
                },
                {
                    name: { english: 'High' },
                    styleConfig: {
                        minValue: 60,
                        maxValue: 80
                    }
                },
                {
                    name: { english: 'Very High' },
                    styleConfig: {
                        minValue: 80,
                        maxValue: 100
                    }
                }
            ]
        }
    ]
};
export const allSiteProfileSpecs = {
    ...conditionsTabProfile,
    ...detailsTabProfile,
    ...benefitsMetadata
};
/*
  To add to Sanity
*/
// On effect or layer pack?
// interface OnSomething {
//   opportunitySummary: IBaseProfileSpec
// }
// interface OnLayerValue {
//   // required for metric layer values only
//   opportunityRanking: TOpportunityRank
// }
// // New site profile one-off object?
// interface OnSomething {
//   conditionsTabProfile: Record<string, IBaseProfileSpec>
//   detailsTabProfile: Record<string, IBaseProfileSpec>
// }
//# sourceMappingURL=siteProfileSpecs.js.map